// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
    display: flex;
    flex-direction: row;
    padding: 0px 18px;
    padding-top: 45px;
    padding-bottom: 19px;
    justify-content: space-between;
    background-color: var(--field-background);
    z-index: 10;
    top: 0;
    right: 0;
    width: 100%;
}

.profile-toast {
    position: absolute;
    top: 46px;
    right: 0px;
    padding: 15px;
    border-radius: 10px;
    background-color: var(--white);
    width: 150px;
    z-index: 99999;
    border: 1px solid var(--field-background);
}

.profile-toast>p,
.header .left-box>p:nth-child(1) {
    color: var(--dark-grey);
    font-family: var(--inter-Medium500);
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 12px;
    word-break: break-all;
}

.header .left-box>p:nth-child(2) {
    color: var(--light-black);
    font-family: var(--Inter-Bold700);
    font-size: 34px;
    line-height: 42px;
    letter-spacing: -0.68px;
}

.header .right-box {
    display: flex;
    flex-direction: row;
    align-items: center
}

.header .right-box>div {
    width: 41px;
    height: 41px;
    background-color: var(--white);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}


.header .right-box>div:nth-child(2) {
    margin-left: 12px;
    position: relative;
}


.icon-container {
    cursor: pointer;
}

.icon-container {
    position: relative !important;
}

.header-icon-style {
    color: '#7525E8';
    width: '24px';
    height: '24px';
}

.header .notifi-icon .notifi-count {
    padding-left: 5px !important;
    padding-right: 5px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/headers/Header.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,oBAAoB;IACpB,8BAA8B;IAC9B,yCAAyC;IACzC,WAAW;IACX,MAAM;IACN,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,cAAc;IACd,yCAAyC;AAC7C;;AAEA;;IAEI,uBAAuB;IACvB,mCAAmC;IACnC,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,iCAAiC;IACjC,eAAe;IACf,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;;AAGA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;;AAGA;IACI,eAAe;AACnB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;AACjC","sourcesContent":[".header {\n    display: flex;\n    flex-direction: row;\n    padding: 0px 18px;\n    padding-top: 45px;\n    padding-bottom: 19px;\n    justify-content: space-between;\n    background-color: var(--field-background);\n    z-index: 10;\n    top: 0;\n    right: 0;\n    width: 100%;\n}\n\n.profile-toast {\n    position: absolute;\n    top: 46px;\n    right: 0px;\n    padding: 15px;\n    border-radius: 10px;\n    background-color: var(--white);\n    width: 150px;\n    z-index: 99999;\n    border: 1px solid var(--field-background);\n}\n\n.profile-toast>p,\n.header .left-box>p:nth-child(1) {\n    color: var(--dark-grey);\n    font-family: var(--inter-Medium500);\n    font-size: 14px;\n    line-height: 24px;\n    margin-bottom: 12px;\n    word-break: break-all;\n}\n\n.header .left-box>p:nth-child(2) {\n    color: var(--light-black);\n    font-family: var(--Inter-Bold700);\n    font-size: 34px;\n    line-height: 42px;\n    letter-spacing: -0.68px;\n}\n\n.header .right-box {\n    display: flex;\n    flex-direction: row;\n    align-items: center\n}\n\n.header .right-box>div {\n    width: 41px;\n    height: 41px;\n    background-color: var(--white);\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n}\n\n\n.header .right-box>div:nth-child(2) {\n    margin-left: 12px;\n    position: relative;\n}\n\n\n.icon-container {\n    cursor: pointer;\n}\n\n.icon-container {\n    position: relative !important;\n}\n\n.header-icon-style {\n    color: '#7525E8';\n    width: '24px';\n    height: '24px';\n}\n\n.header .notifi-icon .notifi-count {\n    padding-left: 5px !important;\n    padding-right: 5px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
